import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Report extends Vue {
  report: any
  showAssignReportModal: boolean = false
  showImportItemModal: boolean = false

  get availablesPartsItems() {
    return this.report.parts.filter((part) => {
      return part.canImportItems === true
    })
  }

  get availablesInformationsFields() {
    return this.availablesPartsItems.map((part) => part.infos).flat()
  }

  get availablesChecklistsFields() {
    return this.availablesPartsItems.map((part) => part.checklists).flat()
  }

  updateItemImport(item) {
    this.showImportItemModal = false

    for (const info of item.informations) {
      const result = this.availablesInformationsFields.find((field) => field.name === info.fieldName)
      if (result) {
        result.value = info.value
      }
    }

    for (const info of item.checklists) {
      const result = this.availablesChecklistsFields.find((field) => field.name === info.fieldName)
      if (result) {
        result.value = info.value
      }
    }
  }
}
